import TGASDK from '@/config/TGASDK'
import logger from '@/helper/logger'
import type { WalletContextType, WalletStatus } from '@/type/wallet'
import { Wallet } from '@kulee/tga-sdk'
import type { UserWallet } from '@kulee/tga-sdk/types/types/wallet'
import { useEffect, useMemo, useState } from 'react'

const useProvideWallet = (): WalletContextType => {
  const { enabled, display } = TGASDK.context.appConfig.feature.wallet
  const DEFAULT_WALLET: Partial<UserWallet> = {
    gold: {
      balance: 0,
      freeze: 0,
      name: '',
      unit: '',
      prefix: '',
      type: 3,
      allowRecharge: false,
      allowWithdraw: false
    },
    diamond: {
      balance: 0,
      freeze: 0,
      name: '',
      unit: '',
      prefix: '',
      type: 2,
      allowRecharge: true,
      allowWithdraw: true
    }
  }
  if (display) {
    // 过滤掉不显示的币种
    if (display.indexOf('DIAMOND') < 0) {
      delete DEFAULT_WALLET.diamond
    }
    if (display.indexOf('GOLD') < 0) {
      delete DEFAULT_WALLET.gold
    }
  }

  const [status, setStatus] = useState<WalletStatus>('unready')
  const [wallet, setWallet] = useState<Partial<UserWallet> | null>(DEFAULT_WALLET)

  // 初始化钱包
  const init = async () => {
    // 钱包功能未开启
    if (!enabled) {
      setStatus('ready')
      return
    }

    try {
      const { data } = await TGASDK.module.Wallet.service.getUserWallet()

      const wallet = data as Partial<UserWallet>
      if (display) {
        // 过滤掉不显示的币种
        if (display.indexOf('DIAMOND') < 0) {
          delete wallet.diamond
        }
        if (display.indexOf('GOLD') < 0) {
          delete wallet.gold
        }
      }

      setWallet(wallet)
      setStatus('ready')
    } catch (error) {
      logger.error('wallet init error', error)
    }
  }

  // 反初始化
  const unInit = () => {
    setWallet(DEFAULT_WALLET)
    setStatus('unready')
  }

  useEffect(() => {
    TGASDK.addModule(Wallet)
  }, [])

  return useMemo(
    () => ({
      status,
      wallet,
      init,
      unInit
    }),
    [status, wallet]
  )
}

export default useProvideWallet
